import React, { memo } from 'react'

import { PhaseMode } from '../../../../../common/domain/electrical-settings'
import useText from '../../../../../common/hooks/useText'
import { ChargePointImport, ConnectorImport } from '../../../../../common/redux/api/web-api'
import { isAuraImport } from '../../../../../lib/isAura'
import { isDawnImport } from '../../../../../lib/isDawn'
import { isHaloImport } from '../../../../../lib/isHalo'
import { isLunaImport } from '../../../../../lib/isLuna'

interface ImportConnectorSettingsProps {
    chargePoint: ChargePointImport
}

export const ImportConnectorSettings = memo((props: ImportConnectorSettingsProps) => {
    const text = useText()
    const connectors = props.chargePoint.connectors ?? []
    const onePVal = (connector: ConnectorImport) => (
        <>
            {text('msgImportInst')}:{connector.installationPhaseMode}-{connector.installationPhase}-
            {connector.installationCurrent}A, LB:
            {connector.loadBalancerOfflinePhase}-{connector.loadBalancerOfflineCurrent}A
        </>
    )

    const threePVal = (connector: ConnectorImport) => (
        <>
            {text('msgImportInst')}:{connector.installationPhaseMode}-{connector.installationCurrent} A, LB:
            {connector.loadBalancerOfflinePhase}-{connector.loadBalancerOfflineCurrent} A
        </>
    )

    const renderConnectorInfo = (connector: ConnectorImport) => {
        return (
            <div>
                {(connector.installationPhaseMode === PhaseMode.onePhase || connector.installationPhaseMode === null) &&
                    onePVal(connector)}
                {connector.installationPhaseMode === PhaseMode.threePhase && threePVal(connector)}
            </div>
        )
    }

    const renderAuraInformation = () =>
        connectors.map((connector, index) => (
            <React.Fragment key={connector.connectorId ?? index}>{renderConnectorInfo(connector)}</React.Fragment>
        ))

    return (
        <div>
            {isAuraImport(props.chargePoint) ? renderAuraInformation() : null}
            {(isHaloImport(props.chargePoint) || isDawnImport(props.chargePoint) || isLunaImport(props.chargePoint)) &&
            connectors[0]
                ? renderConnectorInfo(connectors[0])
                : null}
        </div>
    )
})
